import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/',
            name: 'begin',
            component: () => import("./views/begin.vue"),
            meta: {
                hideTopCut: true,
                allowAnonymous: true,
                closeAppModal: true,
                hideBottomCut: true
            }
        },
        {
            path: '/login',
            name: 'login',
            component: () => import("./views/login.vue"),
            meta: {
                hideTopCut: true,
                allowAnonymous: true,
                closeAppModal: true
            }
        },
        {
            path: '/register',
            name: 'register',
            component: () => import("./views/register.vue"),
            meta: {
                hideTopCut: true,
                allowAnonymous: true
            }
        },
        {
            path: '/completeProfile',
            name: 'completeProfile',
            component: () => import("./views/completeProfile.vue"),
            meta: {
                hideTopCut: true,
            }
        },
        {
            path: '/resetPassword/:userEmail/:token',
            name: 'resetPassword',
            component: () => import("./views/resetPassword.vue"),
            meta: {
                hideTopCut: true,
                allowAnonymous: true
            }
        },
        {
            path: '/change_password',
            name: 'change_password',
            component: () => import("./views/changePassword.vue"),
            meta: {
                hideTopCut: true,
                allowAnonymous: true
            }
        },
        {
            path: '/paymentCompleted',
            name: 'paymentCompleted',
            component: () => import("./views/paymentCompleted.vue"),
            meta: {
                hideTopCut: true,
                allowAnonymous: true
            }
        },
        {
            path: '/confirmEmail/:userIdentifier/:code/:project',
            name: 'confirmEmail',
            component: () => import("./views/confirmEmail.vue"),
            meta: {
                hideTopCut: true,
                allowAnonymous: true
            }
        },
    ];
};